<template>
  <div class="us-agent-tabs-group">
    <div class="us-agent-tabs" role="tablist" aria-label="Role type">
      <button
        type="button"
        class="us-agent-tabs__tab"
        :class="{ 'us-agent-tabs__tab--active': modelValue === USER_ROLE.ADMIN }"
        role="tab"
        :aria-selected="modelValue === USER_ROLE.ADMIN"
        @click="$emit('update:modelValue', USER_ROLE.ADMIN)"
      >
        <v-icon icon="mdi-shield-account-outline" size="15" class="us-agent-tabs__icon" />
        Admin
        <span v-if="adminCount > 0" class="us-agent-tabs__count">{{ adminCount }}</span>
      </button>

      <button
        type="button"
        class="us-agent-tabs__tab"
        :class="{ 'us-agent-tabs__tab--active': modelValue === USER_ROLE.AGENT }"
        role="tab"
        :aria-selected="modelValue === USER_ROLE.AGENT"
        @click="$emit('update:modelValue', USER_ROLE.AGENT)"
      >
        <v-icon icon="mdi-headset" size="15" class="us-agent-tabs__icon" />
        Agent
        <span v-if="agentCount > 0" class="us-agent-tabs__count">{{ agentCount }}</span>
      </button>
    </div>

    <div
      v-if="modelValue === USER_ROLE.AGENT"
      class="us-agent-tabs us-agent-tabs--sub"
      role="tablist"
      aria-label="Agent type"
    >
      <button
        type="button"
        class="us-agent-tabs__tab"
        :class="{ 'us-agent-tabs__tab--active': agentType === AGENT_TYPE.AI }"
        role="tab"
        :aria-selected="agentType === AGENT_TYPE.AI"
        @click="$emit('update:agentType', AGENT_TYPE.AI)"
      >
        <v-icon icon="mdi-robot-outline" size="15" class="us-agent-tabs__icon" />
        AI Agent
        <span v-if="aiCount > 0" class="us-agent-tabs__count">{{ aiCount }}</span>
      </button>

      <button
        type="button"
        class="us-agent-tabs__tab"
        :class="{ 'us-agent-tabs__tab--active': agentType === AGENT_TYPE.HUMAN }"
        role="tab"
        :aria-selected="agentType === AGENT_TYPE.HUMAN"
        @click="$emit('update:agentType', AGENT_TYPE.HUMAN)"
      >
        <v-icon icon="mdi-account-outline" size="15" class="us-agent-tabs__icon" />
        Human Agent
        <span v-if="humanCount > 0" class="us-agent-tabs__count">{{ humanCount }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { AGENT_TYPE, USER_ROLE } from '@/utils/orgUsers'

defineOptions({ name: 'UsersAgentTypeTabs' })

defineProps({
  modelValue: { type: String, default: USER_ROLE.ADMIN },
  agentType: { type: String, default: AGENT_TYPE.AI },
  adminCount: { type: Number, default: 0 },
  agentCount: { type: Number, default: 0 },
  aiCount: { type: Number, default: 0 },
  humanCount: { type: Number, default: 0 },
})

defineEmits(['update:modelValue', 'update:agentType'])
</script>
